import type { CirclesAttributes } from './temConnectionModalHeader.model';

export function createCircleAttributesStack(
  circlesAttributes: CirclesAttributes[],
  circleIndex: number,
  oddNums: number[],
): CirclesAttributes[] {
  if (circleIndex === 0) {
    const initialStrokeDash = 7;
    return [
      {
        size: 227,
        translatey: 40,
        strokeDasharray: [initialStrokeDash, Math.ceil(initialStrokeDash * 1.7)],
        strokeWidth: 1,
        scale: 1,
      },
    ];
  } else {
    const [prevStrokeDashRef] = circlesAttributes[circleIndex - 1].strokeDasharray;
    return [
      ...circlesAttributes,
      {
        size: circlesAttributes[circleIndex - 1].size + 120,
        translatey: circlesAttributes[circleIndex - 1].translatey - 50,
        strokeDasharray: [prevStrokeDashRef - 1, Math.ceil(prevStrokeDashRef * 1.7)],
        strokeWidth: 1 - (circleIndex >= 4 ? 6 : oddNums[circleIndex]) / 10,
        scale: circlesAttributes[circleIndex - 1].scale + 0.5,
      },
    ];
  }
}

export function generateBgCircles(qtt: number): CirclesAttributes[] {
  const oddNums = (Array(qtt).fill(0) as number[]).reduce(
    (accum, _, idx) => (accum.length === 0 ? [1] : [...accum, accum[idx - 1] + 2]),
    [] as number[],
  );

  return Array.from({ length: qtt })
    .fill(undefined)
    .reduce(
      (accum, _, idx) => createCircleAttributesStack(accum as CirclesAttributes[], idx, oddNums),
      [] as CirclesAttributes[],
    ) as CirclesAttributes[];
}

export const qttBgCircles = 5;
